import type { RegistryEntitySummary } from '../../api/registryEntityTypes';
import { isJointHolding } from '../../entities/entityFormat';

export interface EntityFilter {
  key: string;
  label: string;
  test: (entity: RegistryEntitySummary) => boolean;
}

export const ENTITY_FILTERS: EntityFilter[] = [
  { key: 'all', label: 'All', test: () => true },
  { key: 'allocated', label: 'With allocations', test: (entity) => entity.allocationCount > 0 },
  { key: 'joint', label: 'Joint (2+ owners)', test: (entity) => isJointHolding(entity.ownerCount) },
  { key: 'noOwner', label: 'No owner linked', test: (entity) => entity.ownerCount === 0 },
  { key: 'foreign', label: 'Foreign investor', test: (entity) => entity.isForeignInvestor },
];

export function filterEntities(
  entities: RegistryEntitySummary[],
  filterKey: string,
  search: string,
): RegistryEntitySummary[] {
  const filter = ENTITY_FILTERS.find((item) => item.key === filterKey) ?? ENTITY_FILTERS[0];
  const term = search.trim().toLowerCase();
  const digits = term.replace(/\s/g, '');
  return entities.filter(
    (entity) =>
      filter.test(entity) &&
      (!term ||
        entity.name.toLowerCase().includes(term) ||
        Boolean(digits && (entity.abn?.includes(digits) || entity.acn?.includes(digits)))),
  );
}
